<template>
  <VModal ref="modal" @close="$emit('close')">
    <template #default="modalProps">
      <div class="rounded shadow-xs w-full max-w-7xl h-full mx-auto">
        <div class="rounded shadow-lg bg-white flex flex-col h-full">
          <div class="flex-none px-4 sm:px-6 py-5 border-b">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">Email Message</h1>
              </div>

              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="modalProps.close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <Preview :contact-id="contact.id" :email-message-id="emailMessageId" />
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import Preview from './Preview.vue';

export default {
  name: 'ViewEmailMessageDialog',
  components: {
    Preview,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
    emailMessageId: {
      type: String,
      default: null,
    },
  },
};
</script>
